export enum VideoFormat {
  SD = 'SD',
  HD = 'HD',
  UHD = 'UHD',
  NONE = 'NONE'
}

export interface Episode {
  providers: {
    providerType?: string;
    providerName: string;
    length: number;
    covers: {
      '121x176'?: string;
      '135x75'?: string;
      '153x39'?: string;
      '170x75'?: string;
      '183x75'?: string;
      '50x31'?: string;
      '80x30'?: string;
      current?: string;
      overlay?: string;
    };
    hasTrailer?: boolean;
    rentalPeriod?: number;
    unPublishDate?: number;
    access?: boolean;
    previewDuration?: number;
    trailerMediaId?: number;
    lastWatched?: {
      highestTimeIndex?: number;
      lastUpdated?: Date;
      mediaId?: number;
      persistantTimeIndex?: number;
      programLength: number;
      progressBar?: ProgressBar;
      secondsWatched: number;
      eventId?: number;
      sid?: number;
    };
    secondsWatched: number;
    missingSubscriptionText?: string;
    latestWatched?: boolean;
    providerKey?: string;
    providerId?: number;
    versions: {
      airTimeStart?: number;
      readableAirTimeOrRecordingTime?: string;
      resolution?: VideoFormat;
      eventId: number;
      sid: number;
      price?: number;
      isRented?: boolean;
      language?: string;
      subtitles?: string;
      secondsWatched: number;
      unPublishDate?: Date;
      npvrInfo: {
        notSeen: boolean;
        expireAt: Date;
        recordedAt: Date;
        npvrTrickmodes: number;
        customerRecording: boolean;
        isSeriesRecording: boolean;
        recordingStatus: string;
        enoughSpaceForRecording: boolean;
        isNpvrExtendAllowed: boolean;
        extendNpvrEventWithInSec: number;
        npvrMediaId: number;
        expireSoon: boolean;
      };
      rentalExpire?: number;
      latestWatched?: boolean;
      shouldShowContinuePrompt: boolean;
      mediaId?: number;
    }[];
  }[];
  episodeTitle: string;
  shortDescription: string;
  longDescription: string;
  episodeNumber: number;
  seriesId: number;
  seasonId: number;
  seasonNumber: number;
  cast: {
    personId: number;
    firstName: string;
    lastName: string;
    roleName: string;
    job: string;
  }[];
  lastWatched?: {
    highestTimeIndex?: number;
    lastUpdated?: Date;
    mediaId?: number;
    persistantTimeIndex?: number;
    programLength: number;
    progressBar?: ProgressBar;
    secondsWatched: number;
    eventId?: number;
    sid?: number;
  };
  episodeId: number;
  contentType: string;
  cover: string;
  readableAirTimeOrRecordingTime?: string;
  hasProviderAccess: boolean;
  providerAccessNeededText?: string;
  isContentRecorded: boolean;
}

export interface EpisodeExtended extends Episode {
  isNextEventforSeries: boolean;
  channelIcon?: string;
}

export enum ProgressBar {
  DYNAMIC = 'DYNAMIC',
  NONE = 'NONE',
  FULL = 'FULL'
}
